const SHOP_INITIAL_STATE = {
  isFetching: false,
  collections: null,
  errorMessage: undefined,
};

export default SHOP_INITIAL_STATE;
